const images = {
  bg: require("../assets/images/bg.png"),
  logo: require("../assets/images/logo.png"),
  img: require("../assets/images/img.png"),
};

export default images;
